<template>
  <div id="question">
    <ul>
      <li
        v-for="(item, index) in questionArr"
        class="question_box"
        :key="index"
      >
        <img src="http://cdn.yxvzb.com/img/datiImg/datiimgBCD926_17.png" />
        {{ index + 1 + '、' + item.title }}
        <img src="http://cdn.yxvzb.com/img/datiImg/datiimgBCD926_21.png" />
        <br />
        <img src="http://cdn.yxvzb.com/img/datiImg/datiimgBCD926_25.png" />
        <ul @click="chooseAns" :id="index">
          <li :id="['A' + index]" v-show="ansArr[index][0]" class="option">
            <b>A</b>
            {{ ansArr[index][0] }}
          </li>
          <li :id="['B' + index]" v-show="ansArr[index][1]" class="option">
            <b>B</b>
            {{ ansArr[index][1] }}
          </li>
          <li :id="['C' + index]" v-show="ansArr[index][2]" class="option">
            <b>C</b>
            {{ ansArr[index][2] }}
          </li>
          <li :id="['D' + index]" v-show="ansArr[index][3]" class="option">
            <b>D</b>
            {{ ansArr[index][3] }}
          </li>
          <li :id="['E' + index]" v-show="ansArr[index][4]" class="option">
            <b>E</b>
            {{ ansArr[index][4] }}
          </li>
          <li :id="['F' + index]" v-show="ansArr[index][5]" class="option">
            <b>F</b>
            {{ ansArr[index][5] }}
          </li>
        </ul>
      </li>
    </ul>
    <div id="answer" @click="submitAnswer" :disabled="canSend">提交答案</div>
  </div>
</template>
<script>
import { signIn, carveIntegralSignIn } from '@/api/ajax.js';
import { mapState } from 'vuex';
export default {
  name: '',

  data() {
    return {
      title: ['China', 'Japan'],
      value: '',
      data: [
        {
          key: '001',
          value: 'radio001'
        },
        {
          key: '002',
          value: 'radio002'
        }
      ],
      questionArr: [],
      ansArr: [],
      userArr: [],
      answer0: '',
      answer1: '',
      answer2: '',
      trueFlag: true,
      canAns: false,
      canSend: true
    };
  },
  methods: {
    chooseAns(e) {
      var tId = e.target.id;
      var parId = tId.split('')[1];
      var num = tId.split('')[0];
      this.userArr[parId] = num;
      var child = document.getElementById(parId).childNodes;
      for (var i = 0; i < child.length; i++) {
        child[i].className = 'option';
      }
      var tarId = document.getElementById(tId).classList;
      tarId.add('chosen');
    },
    getList() {
      let data = {
        courseId: this.$route.params.id
      };
      signIn.questions(data).then(res => {
        this.questionArr = res.data.data;
        this.questionArr.forEach((item, i) => {
          this.ansArr[i] = [];
          this.ansArr[i].push(
            item.optionA,
            item.optionB,
            item.optionC,
            item.optionD,
            item.optionE,
            item.optionF
          );
        });
      });
    },

    submitAnswer() {
      if (this.questionArr.length == this.userArr.length) {
        this.canAns = true;
        this.trueFlag = true; //修改答案初始化
        for (var i = 0; i < this.questionArr.length; i++) {
          // 判断答案是否填完整
          if (this.questionArr[i].correctAnswer != this.userArr[i]) {
            this.trueFlag = false;
          }
        }
        if (this.canAns) {
          //答案全
          if (this.trueFlag) {
            //如果全部答对
            if (this.wxUserInfo.userDataStatus >= 2) {
              //如果完善信息了
              let data = {
                // type: 1,
                courseId: this.$route.params.id
                // isLiving: this.$route.query.isLiving
              };
              this.canSend = false;
              signIn.ansGetScore(data).then(res => {
                let wxUserInfo = this.wxUserInfo;
                if (this.$route.query.isLiving) {
                  sa.track('qiandao', {
                    course_id: this.$route.params.id,
                    course_name: this.$route.params.id,
                    course_type: 'live',
                    client_id: wxUserInfo.id || wxUserInfo.wxOpenId,
                    client_id: wxUserInfo.id || wxUserInfo.wxOpenId,
                    from: 'wx',
                    web_edition: 2
                  });
                } else {
                  sa.track('qiandao', {
                    course_id: this.$route.params.id,
                    course_name: this.$route.params.id,
                    course_type: 'video',
                    client_id: wxUserInfo.id || wxUserInfo.wxOpenId,
                    client_id: wxUserInfo.id || wxUserInfo.wxOpenId,
                    from: 'wx',
                    web_edition: 2
                  });
                }

                let that = this;
                let courseRouteName = this.$route.query.isLiving
                  ? 'liveDetail'
                  : 'courseDetail';
                if (res.data.stauts != 'error') {
                  this.$vux.toast.show({
                    text: '恭喜您获得' + res.data.data.number + '积分',
                    type: 'text',
                    width: '5rem',
                    onHide() {
                      that.$router.push({
                        name: courseRouteName,
                        params: { id: that.$route.params.id }
                      });
                    }
                  });
                } else {
                  this.$vux.toast.show({
                    text: res.data.message,
                    type: 'error',
                    width: '5rem'
                  });
                }
                //腊八签到活动上报
                // let hours = new Date().getHours()
                // if( hours > 18 && hours < 22 && this.$route.query.isLiving ){
                //   carveIntegralSignIn({courseId:data.courseId}).then(res=>{
                //
                //   })
                // }
              });
              // setTimeout(function () {
              //   window.history.go(-1)
              // }, 2000)
            } else {
              //未完善信息,去完善
              let vm = this;
              this.$vux.toast.show({
                text: '获取积分前请您完善信息',
                type: 'text',
                width: '5rem',
                onHide() {
                  sessionStorage.goBackUrl = location.href;
                  location.href = '/html/perfect.html#/perfect';
                }
              });
            }
          } else {
            this.$vux.toast.show({
              text: '您答错了,请重新选择',
              type: 'text',
              width: '5rem'
            });
          }
        } else {
          //答案不全
          this.$vux.toast.show({
            text: '您尚有答案未填写',
            type: 'cancel',
            width: '5rem'
          });
        }
      }
    }
  },
  computed: {
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    })
  },
  components: {},
  created() {
    this.getList();
  },
  mounted() {}
};
</script>
<style lang="less">
.signIn {
  .weui-cells__title {
    font-size: 0.53rem;
  }
}
</style>
<style lang="less" scoped>
#question {
  .chosen {
    background: lightgrey;
  }
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  .question_box {
    font-size: 0.4rem;
    font-weight: bold;
    margin-top: 0.266667rem;
  }
  .option {
    b {
      color: #47b3ff;
    }
    border-bottom: 1px dashed #000;
    text-align: left;
    padding-top: 0.133333rem;
    padding-bottom: 0.133333rem;
  }
  .hide {
    display: none;
  }
  li {
    text-align: center;
  }
  padding-top: 0.266667rem;
  #answer {
    width: 2.666667rem;
    height: 1.066667rem;
    -webkit-border-radius: 0.666667rem;
    margin: 0 auto;
    margin-top: 0.2rem;
    text-align: center;
    line-height: 1.066667rem;
    color: #fff;
    background: #47b3ff;
    font-size: 0.4rem;
  }
}
</style>
